import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { LffPermissionService } from './lff-permission.service';
import { LffPopAlertService } from './lff-popalert.service';

/**
 * Impedisce l'accesso alle route se non si hanno i permessi
 */
@Injectable()
export class PermissionGuardService implements CanActivate {
  constructor(private router: Router, private permissionService: LffPermissionService, private popAlertService: LffPopAlertService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const params = route.data as { permission: string | string[]; requireAll?: boolean };
    if (!params || !params.permission) {
      this.returnError();
      return false;
    }

    if (this.permissionService.isGranted(params.permission, params.requireAll)) {
      return true;
    }

    this.returnError();
    return false;
  }

  private returnError() {
    this.popAlertService.showErrorMessage('Non possiedi le autorizzazioni necessarie');
    this.router.navigate(['./']);
  }
}
